(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("SXVLB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "$$default", function () { return $0a538840ee0a240b$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $0a538840ee0a240b$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $bjgUL = parcelRequire("bjgUL");

var $ddQhF = parcelRequire("ddQhF");
function $0a538840ee0a240b$export$aa541d093b11ace2(json) {
    performance.mark && performance.mark("Config.decode");
    var result = $bjgUL.decode(json, $ddQhF.fromJson);
    performance.measure && performance.measure("Config.decode", "Config.decode");
    return result;
}
 /* RescriptJsonUtils-Showside Not a pure module */ 
});
parcelRegister("ddQhF", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $9a050bc2a9628251$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $euHt4 = parcelRequire("euHt4");

var $79G3i = parcelRequire("79G3i");

var $ij6do = parcelRequire("ij6do");

var $kNO66 = parcelRequire("kNO66");
var $9a050bc2a9628251$export$7ae2d2a8b28a8cb8 = $iv6Yc.app($jVmMx.Decode.map8, [
    $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string),
    $iv6Yc._2($jVmMx.Decode.field, "categories", $iv6Yc._1($jVmMx.Decode.array, $ij6do.fromJson)),
    $iv6Yc._2($jVmMx.Decode.field, "settings", $kNO66.fromJson),
    $iv6Yc._2($jVmMx.Decode.field, "transitiveStoreId", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "transitiveAccount", $iv6Yc._1($jVmMx.Decode.nullable, $79G3i.Public.fromJson)),
    $jVmMx.Decode.fieldWithDefault("transitiveStore", $iv6Yc._1($jVmMx.Decode.nullable, $euHt4.Public.fromJson), undefined),
    $iv6Yc._2($jVmMx.Decode.field, "accountId", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string)),
    $iv6Yc._2($jVmMx.Decode.field, "lastModifiedAt", $jVmMx.Decode.$$float),
    function(id, categories, settings, transitiveStoreId, transitiveAccount, transitiveStore, accountId, lastModifiedAt) {
        return {
            id: id,
            categories: categories,
            settings: settings,
            transitiveStoreId: transitiveStoreId,
            transitiveAccount: transitiveAccount,
            transitiveStore: transitiveStore,
            accountId: accountId,
            lastModifiedAt: lastModifiedAt
        };
    }
]);
var $9a050bc2a9628251$export$ce5bcb86ca2bfc97;
 /* fromJson Not a pure module */ 
});
parcelRegister("euHt4", function(module, exports) {

$parcel$export(module.exports, "Public", function () { return $a8d595d244c6939c$export$68b4491d6924a6d1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $a8d595d244c6939c$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "platform",
            $jVmMx.Encode.nullable(param.platform, $jVmMx.Encode.string)
        ],
        [
            "platformUrl",
            $jVmMx.Encode.nullable(param.platformUrl, $jVmMx.Encode.string)
        ],
        [
            "shopifyStorefrontAccessToken",
            $jVmMx.Encode.nullable(param.shopifyStorefrontAccessToken, $jVmMx.Encode.string)
        ],
        [
            "shopifyScopes",
            $iv6Yc._2($jVmMx.Encode.array, param.shopifyScopes, $jVmMx.Encode.string)
        ]
    ]);
}
var $a8d595d244c6939c$var$fromJson = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "platform", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "platformUrl", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "shopifyStorefrontAccessToken", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("shopifyScopes", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.string), []), function(id, platform, platformUrl, shopifyStorefrontAccessToken, shopifyScopes) {
    return {
        id: id,
        platform: platform,
        platformUrl: platformUrl,
        shopifyStorefrontAccessToken: shopifyStorefrontAccessToken,
        shopifyScopes: shopifyScopes
    };
});
var $a8d595d244c6939c$var$include = $doJJK.Make({
    toJson: $a8d595d244c6939c$var$toJson,
    fromJson: $a8d595d244c6939c$var$fromJson
});
var $a8d595d244c6939c$var$Public_t_encode = $a8d595d244c6939c$var$include.t_encode;
var $a8d595d244c6939c$var$Public_t_decode = $a8d595d244c6939c$var$include.t_decode;
var $a8d595d244c6939c$var$Public_codec = $a8d595d244c6939c$var$include.codec;
var $a8d595d244c6939c$export$68b4491d6924a6d1 = {
    toJson: $a8d595d244c6939c$var$toJson,
    fromJson: $a8d595d244c6939c$var$fromJson,
    t_encode: $a8d595d244c6939c$var$Public_t_encode,
    t_decode: $a8d595d244c6939c$var$Public_t_decode,
    codec: $a8d595d244c6939c$var$Public_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("79G3i", function(module, exports) {

$parcel$export(module.exports, "Public", function () { return $5359fe5ba89848c8$export$68b4491d6924a6d1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $jVmMx = parcelRequire("jVmMx");

var $fFzkv = parcelRequire("fFzkv");

var $dRfYk = parcelRequire("dRfYk");

var $crJlr = parcelRequire("crJlr");

var $fOw8Z = parcelRequire("fOw8Z");

var $5td17 = parcelRequire("5td17");

var $gkW0h = parcelRequire("gkW0h");

var $hmUAM = parcelRequire("hmUAM");

var $3u0dF = parcelRequire("3u0dF");

var $jLiCS = parcelRequire("jLiCS");

var $1FxyN = parcelRequire("1FxyN");

var $5NmPk = parcelRequire("5NmPk");

var $doWsD = parcelRequire("doWsD");

var $dKt0X = parcelRequire("dKt0X");

var $2KZ1D = parcelRequire("2KZ1D");

var $519Gg = parcelRequire("519Gg");

var $3DzsH = parcelRequire("3DzsH");

var $9BF9g = parcelRequire("9BF9g");

var $f4o9q = parcelRequire("f4o9q");

var $2d3Mr = parcelRequire("2d3Mr");

var $cAXsd = parcelRequire("cAXsd");

var $aHg7U = parcelRequire("aHg7U");
var $5359fe5ba89848c8$var$fromJson = $iv6Yc._2($jVmMx.Decode.andThen, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(id, pdpStackEnabled, pdpStackPosition, pdpStackOffset, pdpStackSize, pdpConfig, pdpHideMediaFromOtherVariants, pdpShowRelatedMedia, pdpRelatedMediaStyle, plpShowRelatedMedia, plpRelatedMediaStyle, filtersConfig, filtersConfig2, lastModifiedAt, facebookPixelId, facebookPixelPageViewEnabled, facebookPixelViewItemEnabled, facebookPixelAddToCartEnabled, facebookPixelAddToWishlistEnabled, connectedInstagramAccount, connectedTiktokAccount, showPoweredByMaker, slug, pinterestTagId, makerPagesSlug, googleAds, connectedGAProperty, deprecated_addToCart, customActions, bioConfigId, customBioScript, isAnalyticsEmailAllowed, analyticsEmailFrequency, overrides, useCustomDimensionForFingerprinting, expandVariantsInProductsListing, eventsPostmessage, eventsWhitelist, productRules, productPriceStyle, productCardStyle, showProductReviews, showProductReviewsCountInPLP, showProductReviewsCountInPDP, cartCountCSSSelector, audienceCreatedOn, optimize, gaMeasurementId, navMenuConfig, allowMultipleEmbedsOnSamePage, siteHeaderCSSSelector, themes) {
    return {
        id: id,
        pdpStackEnabled: pdpStackEnabled,
        pdpStackPosition: pdpStackPosition,
        pdpStackOffset: pdpStackOffset,
        pdpStackSize: pdpStackSize,
        pdpConfig: pdpConfig,
        pdpHideMediaFromOtherVariants: pdpHideMediaFromOtherVariants,
        pdpShowRelatedMedia: pdpShowRelatedMedia,
        pdpRelatedMediaStyle: pdpRelatedMediaStyle,
        plpShowRelatedMedia: plpShowRelatedMedia,
        plpRelatedMediaStyle: plpRelatedMediaStyle,
        filtersConfig: filtersConfig,
        filtersConfig2: filtersConfig2,
        lastModifiedAt: lastModifiedAt,
        facebookPixelId: facebookPixelId,
        facebookPixelPageViewEnabled: facebookPixelPageViewEnabled,
        facebookPixelViewItemEnabled: facebookPixelViewItemEnabled,
        facebookPixelAddToCartEnabled: facebookPixelAddToCartEnabled,
        facebookPixelAddToWishlistEnabled: facebookPixelAddToWishlistEnabled,
        connectedInstagramAccount: connectedInstagramAccount,
        connectedTiktokAccount: connectedTiktokAccount,
        optimize: optimize,
        showPoweredByMaker: showPoweredByMaker,
        slug: slug,
        pinterestTagId: pinterestTagId,
        makerPagesSlug: makerPagesSlug,
        googleAds: googleAds,
        connectedGAProperty: connectedGAProperty,
        deprecated_addToCart: deprecated_addToCart,
        customActions: customActions,
        bioConfigId: bioConfigId,
        customBioScript: customBioScript,
        isAnalyticsEmailAllowed: isAnalyticsEmailAllowed,
        analyticsEmailFrequency: analyticsEmailFrequency,
        overrides: overrides,
        useCustomDimensionForFingerprinting: useCustomDimensionForFingerprinting,
        expandVariantsInProductsListing: expandVariantsInProductsListing,
        eventsPostmessage: eventsPostmessage,
        eventsWhitelist: eventsWhitelist,
        productRules: productRules,
        productPriceStyle: productPriceStyle,
        productCardStyle: productCardStyle,
        showProductReviews: showProductReviews,
        showProductReviewsCountInPLP: showProductReviewsCountInPLP,
        showProductReviewsCountInPDP: showProductReviewsCountInPDP,
        cartCountCSSSelector: cartCountCSSSelector,
        audienceCreatedOn: audienceCreatedOn,
        gaMeasurementId: gaMeasurementId,
        navMenuConfig: navMenuConfig,
        allowMultipleEmbedsOnSamePage: allowMultipleEmbedsOnSamePage,
        siteHeaderCSSSelector: siteHeaderCSSSelector,
        themes: themes
    };
}), $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("pdpStackEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("pdpStackPosition", $3DzsH.PDPStackPosition.fromJson, "left")), $jVmMx.Decode.fieldWithDefault("pdpStackOffset", $2KZ1D.PDPStackOffset.fromJson, {
    left: 0,
    right: 0,
    bottom: 0
})), $jVmMx.Decode.fieldWithDefault("pdpStackSize", $jLiCS.PDPStackSize.fromJson, "sm")), $iv6Yc._2($jVmMx.Decode.field, "pdpConfig", $iv6Yc._1($jVmMx.Decode.option, $519Gg.fromJson))), $jVmMx.Decode.fieldWithDefault("pdpHideMediaFromOtherVariants", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("pdpShowRelatedMedia", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("pdpRelatedMediaStyle", $iv6Yc._1($jVmMx.Decode.option, $5NmPk.RelatedMedia.sliderStyles_fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("plpShowRelatedMedia", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("plpRelatedMediaStyle", $iv6Yc._1($jVmMx.Decode.option, $5NmPk.RelatedMedia.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "filtersConfig", $iv6Yc._1($jVmMx.Decode.option, $fOw8Z.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "filtersConfig2", $iv6Yc._1($jVmMx.Decode.option, $5td17.fromJson))), $iv6Yc._2($jVmMx.Decode.field, "lastModifiedAt", $jVmMx.Decode.$$float)), $iv6Yc._2($jVmMx.Decode.field, "facebookPixelId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("facebookPixelPageViewEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("facebookPixelViewItemEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("facebookPixelAddToCartEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("facebookPixelAddToWishlistEnabled", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("connectedInstagramAccount", $iv6Yc._1($jVmMx.Decode.option, $aHg7U.ConnectedInstagramAccount.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("connectedTiktokAccount", $iv6Yc._1($jVmMx.Decode.option, $cAXsd.ConnectedTiktokAccount.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("showPoweredByMaker", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "slug", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "pinterestTagId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("makerPagesSlug", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $iv6Yc._2($jVmMx.Decode.field, "googleAds", $iv6Yc._1($jVmMx.Decode.option, $hmUAM.GoogleAdsCodecs.fromJson))), $jVmMx.Decode.fieldWithDefault("connectedGAProperty", $iv6Yc._1($jVmMx.Decode.option, $2d3Mr.ConnectedGAPropertyCodecs.fromJson), undefined)), $iv6Yc._2($jVmMx.Decode.field, "addToCart", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $jVmMx.Decode.fieldWithDefault("customActions", $iv6Yc._1($jVmMx.Decode.array, $crJlr.fromJson), [])), $jVmMx.Decode.fieldWithDefault("bioConfigId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("customBioScript", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("isAnalyticsEmailAllowed", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("analyticsEmailFrequency", $dKt0X.EmailFrequency.fromJson, {
    weekly: true,
    monthly: true,
    yearly: true,
    daily: false
})), $jVmMx.Decode.fieldWithDefault("overrides", $iv6Yc._1($jVmMx.Decode.option, $3u0dF.Overrides.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("useCustomDimensionForFingerprinting", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("expandVariantsInProductsListing", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("eventsPostmessage", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("eventsWhitelist", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("productRules", $1FxyN.ProductRules.fromJson, $1FxyN.ProductRules.empty)), $jVmMx.Decode.fieldWithDefault("productPriceStyle", $f4o9q.ProductPriceStyle.fromJson, /* Default */ 0)), $jVmMx.Decode.fieldWithDefault("productCardStyle", $iv6Yc._1($jVmMx.Decode.option, $9BF9g.ProductCardStyle.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("showProductReviews", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showProductReviewsCountInPLP", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("showProductReviewsCountInPDP", $jVmMx.Decode.bool, true)), $jVmMx.Decode.fieldWithDefault("cartCountCSSSelector", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("audienceCreatedOn", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$float), undefined)), $jVmMx.Decode.fieldWithDefault("optimize", $iv6Yc._1($jVmMx.Decode.option, $gkW0h.Optimize.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("gaMeasurementId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("navMenuConfig", $iv6Yc._1($jVmMx.Decode.option, $doWsD.NavMenu.fromJson), undefined)), $jVmMx.Decode.fieldWithDefault("allowMultipleEmbedsOnSamePage", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("siteHeaderCSSSelector", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("themes", $iv6Yc._1($jVmMx.Decode.array, $fFzkv.fromJson), [])), function(result) {
    var deprecated_addToCart = result.deprecated_addToCart;
    var tmp;
    if (deprecated_addToCart !== undefined) {
        var customActions = $i7mYY.concat([
            {
                id: $iv6Yc._1($dRfYk.fromString, "add-to-cart"),
                name: "Add to cart",
                onClickFn: deprecated_addToCart,
                renderFn: undefined,
                addToCart: true
            }
        ], result.customActions);
        var newrecord = $7bjme.obj_dup(result);
        newrecord.customActions = customActions;
        newrecord.deprecated_addToCart = undefined;
        tmp = newrecord;
    } else tmp = result;
    return $iv6Yc._1($jVmMx.Decode.succeed, tmp);
});
var $5359fe5ba89848c8$export$68b4491d6924a6d1 = {
    fromJson: $5359fe5ba89848c8$var$fromJson
};
 /* fromJson Not a pure module */ 
});
parcelRegister("fOw8Z", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $b83475a4cfd08827$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $b83475a4cfd08827$var$color_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "tag",
            $AAkl8.string(param.tag)
        ],
        [
            "colorValue",
            $AAkl8.string(param.colorValue)
        ]
    ]);
}
var $b83475a4cfd08827$var$color_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), $79vie.field("colorValue", $79vie.string), function(id, label, tag, colorValue) {
    return {
        id: id,
        label: label,
        tag: tag,
        colorValue: colorValue
    };
});
function $b83475a4cfd08827$var$image_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "tag",
            $AAkl8.string(param.tag)
        ],
        [
            "imageUrl",
            $AAkl8.string(param.imageUrl)
        ]
    ]);
}
var $b83475a4cfd08827$var$image_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), $79vie.field("imageUrl", $79vie.string), function(id, label, tag, imageUrl) {
    return {
        id: id,
        label: label,
        tag: tag,
        imageUrl: imageUrl
    };
});
function $b83475a4cfd08827$var$checkbox_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "tag",
            $AAkl8.string(param.tag)
        ]
    ]);
}
var $b83475a4cfd08827$var$checkbox_decode = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), function(id, label, tag) {
    return {
        id: id,
        label: label,
        tag: tag
    };
});
var $b83475a4cfd08827$var$intermediate_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("tag", $79vie.string), $79vie.field("value", $79vie.option($79vie.string)), function(id, label, tag, value) {
    return {
        id: id,
        label: label,
        tag: tag,
        value: value
    };
});
var $b83475a4cfd08827$export$6d08773d2e66f8f2 = {
    color_encode: $b83475a4cfd08827$var$color_encode,
    color_decode: $b83475a4cfd08827$var$color_decode,
    image_encode: $b83475a4cfd08827$var$image_encode,
    image_decode: $b83475a4cfd08827$var$image_decode,
    checkbox_encode: $b83475a4cfd08827$var$checkbox_encode,
    checkbox_decode: $b83475a4cfd08827$var$checkbox_decode,
    intermediate_decode: $b83475a4cfd08827$var$intermediate_decode
};
var $b83475a4cfd08827$var$partial_arg = [
    [
        "Tag",
        /* Tag */ 0
    ],
    [
        "Color",
        /* Color */ 1
    ],
    [
        "Size",
        /* Size */ 2
    ],
    [
        "Material",
        /* Material */ 3
    ],
    [
        "Pattern",
        /* Pattern */ 4
    ]
];
function $b83475a4cfd08827$export$5d9e9b4d40c39504(param) {
    return $jVmMx.Encode.simpleVariant($b83475a4cfd08827$var$partial_arg, param);
}
var $b83475a4cfd08827$export$6ac17622fef3953b = $jVmMx.Decode.simpleVariant([
    [
        "Tag",
        /* Tag */ 0
    ],
    [
        "Color",
        /* Color */ 1
    ],
    [
        "Size",
        /* Size */ 2
    ],
    [
        "Material",
        /* Material */ 3
    ],
    [
        "Pattern",
        /* Pattern */ 4
    ]
]);
function $b83475a4cfd08827$export$f663501057cbec00(param) {
    return $AAkl8.object([
        [
            "sectionExtractor",
            $AAkl8.string(param.sectionExtractor)
        ],
        [
            "labelExtractor",
            $AAkl8.string(param.labelExtractor)
        ]
    ]);
}
var $b83475a4cfd08827$export$ba7a19adcaca8bfa = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "sectionExtractor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "labelExtractor", $jVmMx.Decode.string), function(sectionExtractor, labelExtractor) {
    return {
        sectionExtractor: sectionExtractor,
        labelExtractor: labelExtractor
    };
});
function $b83475a4cfd08827$var$data_encode(param, optionsEncoder) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "_type",
            $b83475a4cfd08827$export$5d9e9b4d40c39504(param._type)
        ],
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "options",
            $iv6Yc._2($jVmMx.Encode.array, param.options, optionsEncoder)
        ],
        [
            "importInfo",
            $jVmMx.Encode.nullable(param.importInfo, $b83475a4cfd08827$export$f663501057cbec00)
        ]
    ]);
}
function $b83475a4cfd08827$var$data_decode(decoder) {
    return $79vie.map5($79vie.field("_type", $b83475a4cfd08827$export$6ac17622fef3953b), $79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("options", $79vie.array(decoder)), $79vie.field("importInfo", $79vie.option($b83475a4cfd08827$export$ba7a19adcaca8bfa)), function(_type, id, label, options, importInfo) {
        return {
            _type: _type,
            id: id,
            label: label,
            options: options,
            importInfo: importInfo
        };
    });
}
function $b83475a4cfd08827$var$toJson(v) {
    switch(v.TAG | 0){
        case /* ColorCheckbox */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ColorCheckbox", function(__x) {
                return $b83475a4cfd08827$var$data_encode(__x, $b83475a4cfd08827$var$color_encode);
            });
        case /* ImageCheckbox */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageCheckbox", function(__x) {
                return $b83475a4cfd08827$var$data_encode(__x, $b83475a4cfd08827$var$image_encode);
            });
        case /* Checkbox */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Checkbox", function(__x) {
                return $b83475a4cfd08827$var$data_encode(__x, $b83475a4cfd08827$var$checkbox_encode);
            });
    }
}
var $b83475a4cfd08827$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ColorCheckbox", $b83475a4cfd08827$var$data_decode($b83475a4cfd08827$var$color_decode), function(c) {
    return {
        TAG: /* ColorCheckbox */ 0,
        _0: c
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("ImageCheckbox", $b83475a4cfd08827$var$data_decode($b83475a4cfd08827$var$image_decode), function(i) {
        return {
            TAG: /* ImageCheckbox */ 1,
            _0: i
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Checkbox", $b83475a4cfd08827$var$data_decode($b83475a4cfd08827$var$checkbox_decode), function(c) {
        return {
            TAG: /* Checkbox */ 2,
            _0: c
        };
    })
]);
var $b83475a4cfd08827$export$6e2c8f0811a474ce = {
    data_encode: $b83475a4cfd08827$var$data_encode,
    data_decode: $b83475a4cfd08827$var$data_decode,
    toJson: $b83475a4cfd08827$var$toJson,
    fromJson: $b83475a4cfd08827$var$fromJson
};
function $b83475a4cfd08827$export$d5b7a8bf56ee1fe2(__x) {
    return $AAkl8.array(__x, $b83475a4cfd08827$var$toJson);
}
var $b83475a4cfd08827$export$7ae2d2a8b28a8cb8 = $79vie.array($b83475a4cfd08827$var$fromJson);
var $b83475a4cfd08827$var$include = $doJJK.Make({
    toJson: $b83475a4cfd08827$export$d5b7a8bf56ee1fe2,
    fromJson: $b83475a4cfd08827$export$7ae2d2a8b28a8cb8
});
var $b83475a4cfd08827$export$cc42ff7b6c615091 = $b83475a4cfd08827$var$include.t_encode;
var $b83475a4cfd08827$export$bb5e712207166a02 = $b83475a4cfd08827$var$include.t_decode;
var $b83475a4cfd08827$export$1c37c01eba8ed446 = $b83475a4cfd08827$var$include.codec;
 /* color_decode Not a pure module */ 
});

parcelRegister("5td17", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $3fb9c214fab54956$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $3fb9c214fab54956$var$color_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "facet",
            $AAkl8.string(param.facet)
        ],
        [
            "colorValue",
            $AAkl8.string(param.colorValue)
        ]
    ]);
}
var $3fb9c214fab54956$var$color_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), $79vie.field("colorValue", $79vie.string), function(id, label, facet, colorValue) {
    return {
        id: id,
        label: label,
        facet: facet,
        colorValue: colorValue
    };
});
function $3fb9c214fab54956$var$image_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "facet",
            $AAkl8.string(param.facet)
        ],
        [
            "imageUrl",
            $AAkl8.string(param.imageUrl)
        ]
    ]);
}
var $3fb9c214fab54956$var$image_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), $79vie.field("imageUrl", $79vie.string), function(id, label, facet, imageUrl) {
    return {
        id: id,
        label: label,
        facet: facet,
        imageUrl: imageUrl
    };
});
function $3fb9c214fab54956$var$checkbox_encode(param) {
    return $AAkl8.object([
        [
            "id",
            $AAkl8.string(param.id)
        ],
        [
            "label",
            $AAkl8.string(param.label)
        ],
        [
            "facet",
            $AAkl8.string(param.facet)
        ]
    ]);
}
var $3fb9c214fab54956$var$checkbox_decode = $79vie.map3($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), function(id, label, facet) {
    return {
        id: id,
        label: label,
        facet: facet
    };
});
var $3fb9c214fab54956$var$intermediate_decode = $79vie.map4($79vie.field("id", $79vie.string), $79vie.field("label", $79vie.string), $79vie.field("facet", $79vie.string), $79vie.field("value", $79vie.option($79vie.string)), function(id, label, facet, value) {
    return {
        id: id,
        label: label,
        facet: facet,
        value: value
    };
});
var $3fb9c214fab54956$export$6d08773d2e66f8f2 = {
    color_encode: $3fb9c214fab54956$var$color_encode,
    color_decode: $3fb9c214fab54956$var$color_decode,
    image_encode: $3fb9c214fab54956$var$image_encode,
    image_decode: $3fb9c214fab54956$var$image_decode,
    checkbox_encode: $3fb9c214fab54956$var$checkbox_encode,
    checkbox_decode: $3fb9c214fab54956$var$checkbox_decode,
    intermediate_decode: $3fb9c214fab54956$var$intermediate_decode
};
function $3fb9c214fab54956$var$data_encode(param, optionsEncoder) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "label",
            $iv6Yc._1($jVmMx.Encode.string, param.label)
        ],
        [
            "options",
            $iv6Yc._2($jVmMx.Encode.array, param.options, optionsEncoder)
        ],
        [
            "visible",
            $iv6Yc._1($jVmMx.Encode.bool, param.visible)
        ]
    ]);
}
function $3fb9c214fab54956$var$data_decode(decoder) {
    return $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "label", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "options", $iv6Yc._1($jVmMx.Decode.array, decoder)), $jVmMx.Decode.fieldWithDefault("visible", $jVmMx.Decode.bool, true), function(id, label, options, visible) {
        return {
            id: id,
            label: label,
            options: options,
            visible: visible
        };
    });
}
function $3fb9c214fab54956$var$toJson(v) {
    switch(v.TAG | 0){
        case /* ColorCheckbox */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ColorCheckbox", function(__x) {
                return $3fb9c214fab54956$var$data_encode(__x, $3fb9c214fab54956$var$color_encode);
            });
        case /* ImageCheckbox */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "ImageCheckbox", function(__x) {
                return $3fb9c214fab54956$var$data_encode(__x, $3fb9c214fab54956$var$image_encode);
            });
        case /* Checkbox */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Checkbox", function(__x) {
                return $3fb9c214fab54956$var$data_encode(__x, $3fb9c214fab54956$var$checkbox_encode);
            });
    }
}
var $3fb9c214fab54956$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ColorCheckbox", $3fb9c214fab54956$var$data_decode($3fb9c214fab54956$var$color_decode), function(c) {
    return {
        TAG: /* ColorCheckbox */ 0,
        _0: c
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("ImageCheckbox", $3fb9c214fab54956$var$data_decode($3fb9c214fab54956$var$image_decode), function(i) {
        return {
            TAG: /* ImageCheckbox */ 1,
            _0: i
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Checkbox", $3fb9c214fab54956$var$data_decode($3fb9c214fab54956$var$checkbox_decode), function(c) {
        return {
            TAG: /* Checkbox */ 2,
            _0: c
        };
    })
]);
var $3fb9c214fab54956$export$6e2c8f0811a474ce = {
    data_encode: $3fb9c214fab54956$var$data_encode,
    data_decode: $3fb9c214fab54956$var$data_decode,
    toJson: $3fb9c214fab54956$var$toJson,
    fromJson: $3fb9c214fab54956$var$fromJson
};
function $3fb9c214fab54956$export$d5b7a8bf56ee1fe2(__x) {
    return $AAkl8.array(__x, $3fb9c214fab54956$var$toJson);
}
var $3fb9c214fab54956$export$7ae2d2a8b28a8cb8 = $79vie.array($3fb9c214fab54956$var$fromJson);
var $3fb9c214fab54956$var$include = $doJJK.Make({
    toJson: $3fb9c214fab54956$export$d5b7a8bf56ee1fe2,
    fromJson: $3fb9c214fab54956$export$7ae2d2a8b28a8cb8
});
var $3fb9c214fab54956$export$cc42ff7b6c615091 = $3fb9c214fab54956$var$include.t_encode;
var $3fb9c214fab54956$export$bb5e712207166a02 = $3fb9c214fab54956$var$include.t_decode;
var $3fb9c214fab54956$export$1c37c01eba8ed446 = $3fb9c214fab54956$var$include.codec;
 /* color_decode Not a pure module */ 
});

parcelRegister("gkW0h", function(module, exports) {

$parcel$export(module.exports, "Optimize", function () { return $be4b81dd94def38e$export$b8e51e84bc71aff9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $be4b81dd94def38e$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "isActive",
            $iv6Yc._1($jVmMx.Encode.bool, param.isActive)
        ]
    ]);
}
var $be4b81dd94def38e$var$fromJson = $iv6Yc._2($jVmMx.Decode.map, $jVmMx.Decode.fieldWithDefault("isActive", $jVmMx.Decode.bool, true), function(isActive) {
    return {
        isActive: isActive
    };
});
var $be4b81dd94def38e$var$include = $doJJK.Make({
    toJson: $be4b81dd94def38e$var$toJson,
    fromJson: $be4b81dd94def38e$var$fromJson
});
var $be4b81dd94def38e$var$Optimize_t_encode = $be4b81dd94def38e$var$include.t_encode;
var $be4b81dd94def38e$var$Optimize_t_decode = $be4b81dd94def38e$var$include.t_decode;
var $be4b81dd94def38e$var$Optimize_codec = $be4b81dd94def38e$var$include.codec;
var $be4b81dd94def38e$export$b8e51e84bc71aff9 = {
    toJson: $be4b81dd94def38e$var$toJson,
    fromJson: $be4b81dd94def38e$var$fromJson,
    t_encode: $be4b81dd94def38e$var$Optimize_t_encode,
    t_decode: $be4b81dd94def38e$var$Optimize_t_decode,
    codec: $be4b81dd94def38e$var$Optimize_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("hmUAM", function(module, exports) {

$parcel$export(module.exports, "GoogleAdsCodecs", function () { return $ca5063cca2496149$export$2d5d03092842fd5f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $ca5063cca2496149$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "tagId",
            $jVmMx.Encode.nullable(param.tagId, $jVmMx.Encode.string)
        ],
        [
            "pageViewEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.pageViewEnabled)
        ],
        [
            "pageViewConversionLabel",
            $jVmMx.Encode.nullable(param.pageViewConversionLabel, $jVmMx.Encode.string)
        ],
        [
            "viewItemEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.viewItemEnabled)
        ],
        [
            "viewItemConversionLabel",
            $jVmMx.Encode.nullable(param.viewItemConversionLabel, $jVmMx.Encode.string)
        ],
        [
            "addToCartEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.addToCartEnabled)
        ],
        [
            "addToCartConversionLabel",
            $jVmMx.Encode.nullable(param.addToCartConversionLabel, $jVmMx.Encode.string)
        ]
    ]);
}
var $ca5063cca2496149$var$fromJson = $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "tagId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("pageViewEnabled", $jVmMx.Decode.bool, false), $iv6Yc._2($jVmMx.Decode.field, "pageViewConversionLabel", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("viewItemEnabled", $jVmMx.Decode.bool, true), $iv6Yc._2($jVmMx.Decode.field, "viewItemConversionLabel", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("addToCartEnabled", $jVmMx.Decode.bool, true), $iv6Yc._2($jVmMx.Decode.field, "addToCartConversionLabel", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), function(tagId, pageViewEnabled, pageViewConversionLabel, viewItemEnabled, viewItemConversionLabel, addToCartEnabled, addToCartConversionLabel) {
    return {
        tagId: tagId,
        pageViewEnabled: pageViewEnabled,
        pageViewConversionLabel: pageViewConversionLabel,
        viewItemEnabled: viewItemEnabled,
        viewItemConversionLabel: viewItemConversionLabel,
        addToCartEnabled: addToCartEnabled,
        addToCartConversionLabel: addToCartConversionLabel
    };
});
var $ca5063cca2496149$var$include = $doJJK.Make({
    toJson: $ca5063cca2496149$var$toJson,
    fromJson: $ca5063cca2496149$var$fromJson
});
var $ca5063cca2496149$var$GoogleAdsCodecs_empty = {
    tagId: undefined,
    pageViewEnabled: false,
    pageViewConversionLabel: undefined,
    viewItemEnabled: true,
    viewItemConversionLabel: undefined,
    addToCartEnabled: true,
    addToCartConversionLabel: undefined
};
var $ca5063cca2496149$var$GoogleAdsCodecs_t_encode = $ca5063cca2496149$var$include.t_encode;
var $ca5063cca2496149$var$GoogleAdsCodecs_t_decode = $ca5063cca2496149$var$include.t_decode;
var $ca5063cca2496149$var$GoogleAdsCodecs_codec = $ca5063cca2496149$var$include.codec;
var $ca5063cca2496149$export$2d5d03092842fd5f = {
    toJson: $ca5063cca2496149$var$toJson,
    fromJson: $ca5063cca2496149$var$fromJson,
    empty: $ca5063cca2496149$var$GoogleAdsCodecs_empty,
    t_encode: $ca5063cca2496149$var$GoogleAdsCodecs_t_encode,
    t_decode: $ca5063cca2496149$var$GoogleAdsCodecs_t_decode,
    codec: $ca5063cca2496149$var$GoogleAdsCodecs_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("jLiCS", function(module, exports) {

$parcel$export(module.exports, "PDPStackSize", function () { return $e630dad53c02320a$export$f2f78bc64bec03df; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $e630dad53c02320a$var$partial_arg = [
    [
        "sm",
        "sm"
    ],
    [
        "lg",
        "lg"
    ]
];
function $e630dad53c02320a$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($e630dad53c02320a$var$partial_arg, param);
}
var $e630dad53c02320a$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "sm",
        "sm"
    ],
    [
        "lg",
        "lg"
    ]
]);
var $e630dad53c02320a$var$include = $doJJK.Make({
    toJson: $e630dad53c02320a$var$toJson,
    fromJson: $e630dad53c02320a$var$fromJson
});
var $e630dad53c02320a$var$t_encode = $e630dad53c02320a$var$include.t_encode;
var $e630dad53c02320a$var$t_decode = $e630dad53c02320a$var$include.t_decode;
var $e630dad53c02320a$var$PDPStackSize_codec = $e630dad53c02320a$var$include.codec;
var $e630dad53c02320a$export$f2f78bc64bec03df = {
    toJson: $e630dad53c02320a$var$toJson,
    fromJson: $e630dad53c02320a$var$fromJson,
    t_encode: $e630dad53c02320a$var$t_encode,
    t_decode: $e630dad53c02320a$var$t_decode,
    codec: $e630dad53c02320a$var$PDPStackSize_codec
};
var $e630dad53c02320a$export$ccd9022e0f959c9e = $e630dad53c02320a$var$t_encode;
var $e630dad53c02320a$export$b3b3171d8f08f6d6 = $e630dad53c02320a$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("1FxyN", function(module, exports) {

$parcel$export(module.exports, "ProductRules", function () { return $1373a71edb2a434a$export$1fa40822353c573d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");

var $5Ax4c = parcelRequire("5Ax4c");
function $1373a71edb2a434a$var$customAddToCartText_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "rule",
            $5Ax4c.toJson(param.rule)
        ],
        [
            "text",
            $iv6Yc._1($jVmMx.Encode.string, param.text)
        ],
        [
            "overrideOutOfStock",
            $iv6Yc._1($jVmMx.Encode.bool, param.overrideOutOfStock)
        ]
    ]);
}
var $1373a71edb2a434a$var$customAddToCartText_fromJson = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "rule", $5Ax4c.fromJson(undefined)), $iv6Yc._2($jVmMx.Decode.field, "text", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("overrideOutOfStock", $jVmMx.Decode.bool, false), function(rule, text, overrideOutOfStock) {
    return {
        rule: rule,
        text: text,
        overrideOutOfStock: overrideOutOfStock
    };
});
function $1373a71edb2a434a$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "hideAddToCartButton",
            $jVmMx.Encode.nullable(param.hideAddToCartButton, $5Ax4c.toJson)
        ],
        [
            "customAddToCartText",
            $jVmMx.Encode.nullable(param.customAddToCartText, $1373a71edb2a434a$var$customAddToCartText_toJson)
        ],
        [
            "hideOpenLinkButton",
            $jVmMx.Encode.nullable(param.hideOpenLinkButton, $5Ax4c.toJson)
        ]
    ]);
}
var $1373a71edb2a434a$var$fromJson = $iv6Yc._4($jVmMx.Decode.map3, $jVmMx.Decode.fieldWithDefault("hideAddToCartButton", $iv6Yc._1($jVmMx.Decode.option, $5Ax4c.fromJson(undefined)), undefined), $jVmMx.Decode.fieldWithDefault("customAddToCartText", $iv6Yc._1($jVmMx.Decode.option, $1373a71edb2a434a$var$customAddToCartText_fromJson), undefined), $jVmMx.Decode.fieldWithDefault("hideOpenLinkButton", $iv6Yc._1($jVmMx.Decode.option, $5Ax4c.fromJson(undefined)), undefined), function(hideAddToCartButton, customAddToCartText, hideOpenLinkButton) {
    return {
        hideAddToCartButton: hideAddToCartButton,
        customAddToCartText: customAddToCartText,
        hideOpenLinkButton: hideOpenLinkButton
    };
});
var $1373a71edb2a434a$var$include = $doJJK.Make({
    toJson: $1373a71edb2a434a$var$toJson,
    fromJson: $1373a71edb2a434a$var$fromJson
});
var $1373a71edb2a434a$var$t_encode = $1373a71edb2a434a$var$include.t_encode;
var $1373a71edb2a434a$var$t_decode = $1373a71edb2a434a$var$include.t_decode;
var $1373a71edb2a434a$var$ProductRules_empty = {
    hideAddToCartButton: undefined,
    customAddToCartText: undefined,
    hideOpenLinkButton: undefined
};
var $1373a71edb2a434a$var$ProductRules_codec = $1373a71edb2a434a$var$include.codec;
var $1373a71edb2a434a$export$1fa40822353c573d = {
    customAddToCartText_toJson: $1373a71edb2a434a$var$customAddToCartText_toJson,
    customAddToCartText_fromJson: $1373a71edb2a434a$var$customAddToCartText_fromJson,
    toJson: $1373a71edb2a434a$var$toJson,
    fromJson: $1373a71edb2a434a$var$fromJson,
    empty: $1373a71edb2a434a$var$ProductRules_empty,
    t_encode: $1373a71edb2a434a$var$t_encode,
    t_decode: $1373a71edb2a434a$var$t_decode,
    codec: $1373a71edb2a434a$var$ProductRules_codec
};
var $1373a71edb2a434a$export$7705977b4a99ae42 = $1373a71edb2a434a$var$t_encode;
var $1373a71edb2a434a$export$b072445cfa6f9311 = $1373a71edb2a434a$var$t_decode;
 /* customAddToCartText_fromJson Not a pure module */ 
});
parcelRegister("5Ax4c", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $4119f6e7443e0fed$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $4119f6e7443e0fed$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $jVmMx = parcelRequire("jVmMx");

var $jkQEU = parcelRequire("jkQEU");
function $4119f6e7443e0fed$var$toJson(stringCondition) {
    switch(stringCondition.TAG | 0){
        case /* EqualsTo */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(stringCondition._0, "EqualsTo", $jVmMx.Encode.string);
        case /* Contains */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(stringCondition._0, "Contains", $jVmMx.Encode.string);
        case /* NotEqualsTo */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(stringCondition._0, "NotEqualsTo", $jVmMx.Encode.string);
    }
}
var $4119f6e7443e0fed$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("EqualsTo", $jVmMx.Decode.string, function(payload) {
    return {
        TAG: /* EqualsTo */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Contains", $jVmMx.Decode.string, function(payload) {
        return {
            TAG: /* Contains */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("NotEqualsTo", $jVmMx.Decode.string, function(payload) {
        return {
            TAG: /* NotEqualsTo */ 2,
            _0: payload
        };
    })
]);
var $4119f6e7443e0fed$export$ef4a1c06c1da1817 = {
    toJson: $4119f6e7443e0fed$var$toJson,
    fromJson: $4119f6e7443e0fed$var$fromJson
};
function $4119f6e7443e0fed$var$toJson$1(t) {
    switch(t.TAG | 0){
        case /* EqualsTo */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "EqualsTo", $jVmMx.Encode.$$float);
        case /* NotEqualsTo */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "NotEqualsTo", $jVmMx.Encode.$$float);
        case /* GreaterThan */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThan", $jVmMx.Encode.$$float);
        case /* GreaterThanOrEqualsTo */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThanOrEqualsTo", $jVmMx.Encode.$$float);
        case /* LessThan */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThan", $jVmMx.Encode.$$float);
        case /* LessThanOrEqualsTo */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThanOrEqualsTo", $jVmMx.Encode.$$float);
    }
}
var $4119f6e7443e0fed$var$fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("EqualsTo", $jVmMx.Decode.$$float, function(payload) {
    return {
        TAG: /* EqualsTo */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("NotEqualsTo", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* NotEqualsTo */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThan", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* GreaterThan */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThanOrEqualsTo", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* GreaterThanOrEqualsTo */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThan", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* LessThan */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThanOrEqualsTo", $jVmMx.Decode.$$float, function(payload) {
        return {
            TAG: /* LessThanOrEqualsTo */ 5,
            _0: payload
        };
    })
]);
var $4119f6e7443e0fed$export$2cbe3d8ade9bdc14 = {
    toJson: $4119f6e7443e0fed$var$toJson$1,
    fromJson: $4119f6e7443e0fed$var$fromJson$1
};
function $4119f6e7443e0fed$var$toJson$2(t) {
    switch(t.TAG | 0){
        case /* EqualsTo */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "EqualsTo", $jVmMx.Encode.$$int);
        case /* NotEqualsTo */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "NotEqualsTo", $jVmMx.Encode.$$int);
        case /* GreaterThan */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThan", $jVmMx.Encode.$$int);
        case /* GreaterThanOrEqualsTo */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "GreaterThanOrEqualsTo", $jVmMx.Encode.$$int);
        case /* LessThan */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThan", $jVmMx.Encode.$$int);
        case /* LessThanOrEqualsTo */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "LessThanOrEqualsTo", $jVmMx.Encode.$$int);
    }
}
var $4119f6e7443e0fed$var$fromJson$2 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("EqualsTo", $jVmMx.Decode.$$int, function(payload) {
    return {
        TAG: /* EqualsTo */ 0,
        _0: payload
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("NotEqualsTo", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* NotEqualsTo */ 1,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThan", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* GreaterThan */ 2,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("GreaterThanOrEqualsTo", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* GreaterThanOrEqualsTo */ 3,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThan", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* LessThan */ 4,
            _0: payload
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("LessThanOrEqualsTo", $jVmMx.Decode.$$int, function(payload) {
        return {
            TAG: /* LessThanOrEqualsTo */ 5,
            _0: payload
        };
    })
]);
var $4119f6e7443e0fed$export$da3abb9be5cc0ffa = {
    toJson: $4119f6e7443e0fed$var$toJson$2,
    fromJson: $4119f6e7443e0fed$var$fromJson$2
};
function $4119f6e7443e0fed$var$toJson$3(arrayCondition, payloadEncoder) {
    if (arrayCondition.TAG === /* Any */ 0) return $jVmMx.Encode.deccoVariantWithPayload(arrayCondition._0, "Any", payloadEncoder);
    else return $jVmMx.Encode.deccoVariantWithPayload(arrayCondition._0, "NotAny", payloadEncoder);
}
function $4119f6e7443e0fed$var$fromJson$3(payloadDecoder) {
    return $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Any", payloadDecoder, function(payload) {
        return {
            TAG: /* Any */ 0,
            _0: payload
        };
    }), [
        $jVmMx.Decode.deccoVariantWithPayload("NotAny", payloadDecoder, function(payload) {
            return {
                TAG: /* NotAny */ 1,
                _0: payload
            };
        })
    ]);
}
var $4119f6e7443e0fed$export$9867bc6065674be0 = {
    toJson: $4119f6e7443e0fed$var$toJson$3,
    fromJson: $4119f6e7443e0fed$var$fromJson$3
};
function $4119f6e7443e0fed$var$toJson$4(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$3(param.condition, $4119f6e7443e0fed$var$toJson)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$4 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$3($4119f6e7443e0fed$var$fromJson)), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$f8f1308682b8f2d2 = {
    toJson: $4119f6e7443e0fed$var$toJson$4,
    fromJson: $4119f6e7443e0fed$var$fromJson$4
};
function $4119f6e7443e0fed$var$toJson$5(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$5 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$11b099a658b17995 = {
    toJson: $4119f6e7443e0fed$var$toJson$5,
    fromJson: $4119f6e7443e0fed$var$fromJson$5
};
function $4119f6e7443e0fed$var$toJson$6(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$3(param.condition, $4119f6e7443e0fed$var$toJson)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$6 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$3($4119f6e7443e0fed$var$fromJson)), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$877f3fa7327cd466 = {
    toJson: $4119f6e7443e0fed$var$toJson$6,
    fromJson: $4119f6e7443e0fed$var$fromJson$6
};
function $4119f6e7443e0fed$var$toJson$7(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "metadataKey",
            $AAkl8.string(param.metadataKey)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$7 = $79vie.map3($79vie.field("id", $jkQEU.fromJson), $79vie.field("metadataKey", $79vie.string), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson), function(id, metadataKey, condition) {
    return {
        id: id,
        metadataKey: metadataKey,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$fec6d490dd749df0 = {
    toJson: $4119f6e7443e0fed$var$toJson$7,
    fromJson: $4119f6e7443e0fed$var$fromJson$7
};
function $4119f6e7443e0fed$var$toJson$8(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$1(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$8 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$1), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$2ce953db205a18d3 = {
    toJson: $4119f6e7443e0fed$var$toJson$8,
    fromJson: $4119f6e7443e0fed$var$fromJson$8
};
function $4119f6e7443e0fed$var$toJson$9(param) {
    return $AAkl8.object([
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "condition",
            $4119f6e7443e0fed$var$toJson$2(param.condition)
        ]
    ]);
}
var $4119f6e7443e0fed$var$fromJson$9 = $79vie.map2($79vie.field("id", $jkQEU.fromJson), $79vie.field("condition", $4119f6e7443e0fed$var$fromJson$2), function(id, condition) {
    return {
        id: id,
        condition: condition
    };
});
var $4119f6e7443e0fed$export$2e4246fb755f537f = {
    toJson: $4119f6e7443e0fed$var$toJson$9,
    fromJson: $4119f6e7443e0fed$var$fromJson$9
};
function $4119f6e7443e0fed$var$toJson$10(op) {
    return $jVmMx.Encode.simpleVariant([
        [
            "And",
            /* And */ 0
        ],
        [
            "Or",
            /* Or */ 1
        ]
    ], op);
}
var $4119f6e7443e0fed$var$fromJson$10 = $jVmMx.Decode.simpleVariant([
    [
        "And",
        /* And */ 0
    ],
    [
        "Or",
        /* Or */ 1
    ]
]);
var $4119f6e7443e0fed$export$fc1f61f0deaddd66 = {
    toJson: $4119f6e7443e0fed$var$toJson$10,
    fromJson: $4119f6e7443e0fed$var$fromJson$10
};
function $4119f6e7443e0fed$var$toJson$11(encoder, param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jkQEU.toJson, param.id)
        ],
        [
            "rules",
            $iv6Yc._2($jVmMx.Encode.array, param.rules, encoder)
        ],
        [
            "op",
            $4119f6e7443e0fed$var$toJson$10(param.op)
        ]
    ]);
}
function $4119f6e7443e0fed$var$fromJson$11(decoder) {
    return $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "id", $jkQEU.fromJson), $iv6Yc._2($jVmMx.Decode.field, "rules", $iv6Yc._1($jVmMx.Decode.array, $jVmMx.Decode.lazy_(decoder))), $iv6Yc._2($jVmMx.Decode.field, "op", $4119f6e7443e0fed$var$fromJson$10), function(id, rules, op) {
        return {
            id: id,
            op: op,
            rules: rules
        };
    });
}
var $4119f6e7443e0fed$export$7f941bf77681be15 = {
    toJson: $4119f6e7443e0fed$var$toJson$11,
    fromJson: $4119f6e7443e0fed$var$fromJson$11
};
function $4119f6e7443e0fed$export$d5b7a8bf56ee1fe2(t) {
    switch(t.TAG | 0){
        case /* ProductTags */ 0:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductTags", $4119f6e7443e0fed$var$toJson$4);
        case /* ProductType */ 1:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductType", $4119f6e7443e0fed$var$toJson$5);
        case /* CustomLabels */ 2:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "CustomLabels", $4119f6e7443e0fed$var$toJson$6);
        case /* ProductMetaData */ 3:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductMetaData", $4119f6e7443e0fed$var$toJson$7);
        case /* ProductPrice */ 4:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductPrice", $4119f6e7443e0fed$var$toJson$8);
        case /* ProductQuantity */ 5:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "ProductQuantity", $4119f6e7443e0fed$var$toJson$9);
        case /* CompoundRule */ 6:
            return $jVmMx.Encode.deccoVariantWithPayload(t._0, "CompoundRule", function(param) {
                return $4119f6e7443e0fed$var$toJson$11($4119f6e7443e0fed$export$d5b7a8bf56ee1fe2, param);
            });
    }
}
function $4119f6e7443e0fed$export$7ae2d2a8b28a8cb8(param) {
    return $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ProductTags", $4119f6e7443e0fed$var$fromJson$4, function(payload) {
        return {
            TAG: /* ProductTags */ 0,
            _0: payload
        };
    }), [
        $jVmMx.Decode.deccoVariantWithPayload("ProductType", $4119f6e7443e0fed$var$fromJson$5, function(payload) {
            return {
                TAG: /* ProductType */ 1,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("CustomLabels", $4119f6e7443e0fed$var$fromJson$6, function(payload) {
            return {
                TAG: /* CustomLabels */ 2,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ProductMetaData", $4119f6e7443e0fed$var$fromJson$7, function(payload) {
            return {
                TAG: /* ProductMetaData */ 3,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ProductPrice", $4119f6e7443e0fed$var$fromJson$8, function(payload) {
            return {
                TAG: /* ProductPrice */ 4,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("ProductQuantity", $4119f6e7443e0fed$var$fromJson$9, function(payload) {
            return {
                TAG: /* ProductQuantity */ 5,
                _0: payload
            };
        }),
        $jVmMx.Decode.deccoVariantWithPayload("CompoundRule", $4119f6e7443e0fed$var$fromJson$11($4119f6e7443e0fed$export$7ae2d2a8b28a8cb8), function(payload) {
            return {
                TAG: /* CompoundRule */ 6,
                _0: payload
            };
        })
    ]);
}
 /* fromJson Not a pure module */ 
});
parcelRegister("jkQEU", function(module, exports) {

$parcel$export(module.exports, "toJson", function () { return $e138bb890c1a8733$export$d5b7a8bf56ee1fe2; });
$parcel$export(module.exports, "fromJson", function () { return $e138bb890c1a8733$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $e138bb890c1a8733$export$46b83a6aabf254e3 = $ki9MN.Make({});
var $e138bb890c1a8733$export$bb5e712207166a02 = $e138bb890c1a8733$export$46b83a6aabf254e3.t_decode;
var $e138bb890c1a8733$export$cc42ff7b6c615091 = $e138bb890c1a8733$export$46b83a6aabf254e3.t_encode;
var $e138bb890c1a8733$export$3004f64547af360e = $e138bb890c1a8733$export$46b83a6aabf254e3.fromString;
var $e138bb890c1a8733$export$f84e8e69fd4488a5 = $e138bb890c1a8733$export$46b83a6aabf254e3.toString;
var $e138bb890c1a8733$export$d5b7a8bf56ee1fe2 = $e138bb890c1a8733$export$46b83a6aabf254e3.toJson;
var $e138bb890c1a8733$export$7ae2d2a8b28a8cb8 = $e138bb890c1a8733$export$46b83a6aabf254e3.fromJson;
 /* Id Not a pure module */ 
});



parcelRegister("5NmPk", function(module, exports) {

$parcel$export(module.exports, "RelatedMedia", function () { return $43833c51e9860c01$export$b603cdf0301ce8bf; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $43833c51e9860c01$var$customShape_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "width",
            $iv6Yc._1($jVmMx.Encode.$$int, param.width)
        ],
        [
            "height",
            $iv6Yc._1($jVmMx.Encode.$$int, param.height)
        ]
    ]);
}
var $43833c51e9860c01$var$customShape_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "width", $jVmMx.Decode.$$int), $iv6Yc._2($jVmMx.Decode.field, "height", $jVmMx.Decode.$$int), function(width, height) {
    return {
        width: width,
        height: height
    };
});
function $43833c51e9860c01$var$shape_toJson(v) {
    if (typeof v !== "number") return $jVmMx.Encode.deccoVariantWithPayload(v._0, "Custom", $43833c51e9860c01$var$customShape_toJson);
    switch(v){
        case /* Tall */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Tall"
            ], $jVmMx.Encode.string);
        case /* Square */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Square"
            ], $jVmMx.Encode.string);
        case /* Circle */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Circle"
            ], $jVmMx.Encode.string);
    }
}
var $43833c51e9860c01$var$customDecoder = $jVmMx.Decode.deccoVariantWithPayload("Custom", $43833c51e9860c01$var$customShape_fromJson, function(param) {
    return /* Custom */ {
        _0: {
            width: param.width,
            height: param.height
        }
    };
});
var $43833c51e9860c01$var$shape_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $43833c51e9860c01$var$customDecoder, [
    $jVmMx.Decode.simpleVariant([
        [
            "Circle",
            /* Circle */ 2
        ],
        [
            "Square",
            /* Square */ 1
        ],
        [
            "Tall",
            /* Tall */ 0
        ]
    ])
]);
function $43833c51e9860c01$var$size_toJson(v) {
    switch(v){
        case /* Small */ 0:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Small"
            ], $jVmMx.Encode.string);
        case /* Medium */ 1:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Medium"
            ], $jVmMx.Encode.string);
        case /* Large */ 2:
            return $iv6Yc._2($jVmMx.Encode.array, [
                "Large"
            ], $jVmMx.Encode.string);
    }
}
var $43833c51e9860c01$var$size_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Small",
        /* Small */ 0
    ],
    [
        "Medium",
        /* Medium */ 1
    ],
    [
        "Large",
        /* Large */ 2
    ]
]);
function $43833c51e9860c01$var$sliderStyles_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "shape",
            $43833c51e9860c01$var$shape_toJson(param.shape)
        ],
        [
            "size",
            $43833c51e9860c01$var$size_toJson(param.size)
        ]
    ]);
}
var $43833c51e9860c01$var$sliderStyles_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "shape", $43833c51e9860c01$var$shape_fromJson), $iv6Yc._2($jVmMx.Decode.field, "size", $43833c51e9860c01$var$size_fromJson), function(shape, size) {
    return {
        shape: shape,
        size: size
    };
});
function $43833c51e9860c01$var$inlineStyles_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "span",
            $43833c51e9860c01$var$customShape_toJson(param.span)
        ],
        [
            "startRowOffset",
            $iv6Yc._1($jVmMx.Encode.$$int, param.startRowOffset)
        ]
    ]);
}
var $43833c51e9860c01$var$inlineStyles_fromJson = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "span", $43833c51e9860c01$var$customShape_fromJson), $iv6Yc._2($jVmMx.Decode.field, "startRowOffset", $jVmMx.Decode.$$int), function(span, startRowOffset) {
    return {
        span: span,
        startRowOffset: startRowOffset
    };
});
function $43833c51e9860c01$var$toJson(v) {
    if (v.TAG === /* SliderLayout */ 0) return $jVmMx.Encode.deccoVariantWithPayload(v._0, "SliderLayout", $43833c51e9860c01$var$sliderStyles_toJson);
    else return $jVmMx.Encode.deccoVariantWithPayload(v._0, "InlineLayout", $43833c51e9860c01$var$inlineStyles_toJson);
}
var $43833c51e9860c01$var$fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("SliderLayout", $43833c51e9860c01$var$sliderStyles_fromJson, function(styles) {
    return {
        TAG: /* SliderLayout */ 0,
        _0: styles
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("InlineLayout", $43833c51e9860c01$var$inlineStyles_fromJson, function(styles) {
        return {
            TAG: /* InlineLayout */ 1,
            _0: styles
        };
    })
]);
var $43833c51e9860c01$var$include = $doJJK.Make({
    toJson: $43833c51e9860c01$var$toJson,
    fromJson: $43833c51e9860c01$var$fromJson
});
var $43833c51e9860c01$var$RelatedMedia_t_encode = $43833c51e9860c01$var$include.t_encode;
var $43833c51e9860c01$var$RelatedMedia_t_decode = $43833c51e9860c01$var$include.t_decode;
var $43833c51e9860c01$var$RelatedMedia_codec = $43833c51e9860c01$var$include.codec;
var $43833c51e9860c01$export$b603cdf0301ce8bf = {
    customShape_toJson: $43833c51e9860c01$var$customShape_toJson,
    customShape_fromJson: $43833c51e9860c01$var$customShape_fromJson,
    shape_toJson: $43833c51e9860c01$var$shape_toJson,
    shape_fromJson: $43833c51e9860c01$var$shape_fromJson,
    size_toJson: $43833c51e9860c01$var$size_toJson,
    size_fromJson: $43833c51e9860c01$var$size_fromJson,
    sliderStyles_toJson: $43833c51e9860c01$var$sliderStyles_toJson,
    sliderStyles_fromJson: $43833c51e9860c01$var$sliderStyles_fromJson,
    inlineStyles_toJson: $43833c51e9860c01$var$inlineStyles_toJson,
    inlineStyles_fromJson: $43833c51e9860c01$var$inlineStyles_fromJson,
    toJson: $43833c51e9860c01$var$toJson,
    fromJson: $43833c51e9860c01$var$fromJson,
    t_encode: $43833c51e9860c01$var$RelatedMedia_t_encode,
    t_decode: $43833c51e9860c01$var$RelatedMedia_t_decode,
    codec: $43833c51e9860c01$var$RelatedMedia_codec
};
 /* customShape_fromJson Not a pure module */ 
});

parcelRegister("doWsD", function(module, exports) {

$parcel$export(module.exports, "NavMenu", function () { return $9c1add5e29ec5c23$export$a6edb1992047cc25; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
var $9c1add5e29ec5c23$var$partial_arg = [
    [
        "InsertModeReplace",
        /* InsertModeReplace */ 0
    ],
    [
        "InsertModeAppend",
        /* InsertModeAppend */ 1
    ]
];
function $9c1add5e29ec5c23$var$insertMode_toJson(param) {
    return $jVmMx.Encode.simpleVariant($9c1add5e29ec5c23$var$partial_arg, param);
}
var $9c1add5e29ec5c23$var$insertMode_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "InsertModeReplace",
        /* InsertModeReplace */ 0
    ],
    [
        "InsertModeAppend",
        /* InsertModeAppend */ 1
    ]
]);
function $9c1add5e29ec5c23$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "topbarTarget",
            $jVmMx.Encode.nullable(param.topbarTarget, $jVmMx.Encode.string)
        ],
        [
            "topbarTargetStyle",
            $jVmMx.Encode.nullable(param.topbarTargetStyle, $jVmMx.Encode.string)
        ],
        [
            "topbarZIndex",
            $jVmMx.Encode.nullable(param.topbarZIndex, $jVmMx.Encode.$$int)
        ],
        [
            "topbarContainerTarget",
            $jVmMx.Encode.nullable(param.topbarContainerTarget, $jVmMx.Encode.string)
        ],
        [
            "topbarThreeColumnLayout",
            $jVmMx.Encode.nullable(param.topbarThreeColumnLayout, $jVmMx.Encode.bool)
        ],
        [
            "topbarHomeEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.topbarHomeEnabled)
        ],
        [
            "topbarInsertMode",
            $iv6Yc._1($9c1add5e29ec5c23$var$insertMode_toJson, param.topbarInsertMode)
        ],
        [
            "topbarEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.topbarEnabled)
        ],
        [
            "hamburgerTarget",
            $jVmMx.Encode.nullable(param.hamburgerTarget, $jVmMx.Encode.string)
        ],
        [
            "hamburgerTargetStyle",
            $jVmMx.Encode.nullable(param.hamburgerTargetStyle, $jVmMx.Encode.string)
        ],
        [
            "hamburgerZIndex",
            $jVmMx.Encode.nullable(param.hamburgerZIndex, $jVmMx.Encode.$$int)
        ],
        [
            "hamburgerContainerTarget",
            $jVmMx.Encode.nullable(param.hamburgerContainerTarget, $jVmMx.Encode.string)
        ],
        [
            "hamburgerTriggerButtonTarget",
            $jVmMx.Encode.nullable(param.hamburgerTriggerButtonTarget, $jVmMx.Encode.string)
        ],
        [
            "hamburgerHomeEnabled",
            $iv6Yc._1($jVmMx.Encode.bool, param.hamburgerHomeEnabled)
        ],
        [
            "injectCSS",
            $jVmMx.Encode.nullable(param.injectCSS, $jVmMx.Encode.string)
        ],
        [
            "injectJS",
            $jVmMx.Encode.nullable(param.injectJS, $jVmMx.Encode.string)
        ],
        [
            "breakpointMaxWidth",
            $jVmMx.Encode.nullable(param.breakpointMaxWidth, $jVmMx.Encode.$$int)
        ]
    ]);
}
var $9c1add5e29ec5c23$var$fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(topbarTarget, topbarTargetStyle, topbarZIndex, topbarContainerTarget, topbarThreeColumnLayout, topbarHomeEnabled, topbarInsertMode, topbarEnabled, hamburgerTarget, hamburgerTargetStyle, hamburgerZIndex, hamburgerContainerTarget, hamburgerTriggerButtonTarget, hamburgerHomeEnabled, injectCSS, injectJS, breakpointMaxWidth) {
    return {
        topbarTarget: topbarTarget,
        topbarTargetStyle: topbarTargetStyle,
        topbarZIndex: topbarZIndex,
        topbarContainerTarget: topbarContainerTarget,
        topbarThreeColumnLayout: topbarThreeColumnLayout,
        topbarInsertMode: topbarInsertMode,
        topbarEnabled: topbarEnabled,
        topbarHomeEnabled: topbarHomeEnabled,
        hamburgerTarget: hamburgerTarget,
        hamburgerTargetStyle: hamburgerTargetStyle,
        hamburgerContainerTarget: hamburgerContainerTarget,
        hamburgerTriggerButtonTarget: hamburgerTriggerButtonTarget,
        hamburgerZIndex: hamburgerZIndex,
        hamburgerHomeEnabled: hamburgerHomeEnabled,
        injectCSS: injectCSS,
        injectJS: injectJS,
        breakpointMaxWidth: breakpointMaxWidth
    };
}), $iv6Yc._2($jVmMx.Decode.field, "topbarTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "topbarTargetStyle", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "topbarZIndex", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $jVmMx.Decode.fieldWithDefault("topbarContainerTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("topbarThreeColumnLayout", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined)), $jVmMx.Decode.fieldWithDefault("topbarHomeEnabled", $jVmMx.Decode.bool, false)), $jVmMx.Decode.fieldWithDefault("topbarInsertMode", $9c1add5e29ec5c23$var$insertMode_fromJson, /* InsertModeReplace */ 0)), $jVmMx.Decode.fieldWithDefault("topbarEnabled", $jVmMx.Decode.bool, true)), $iv6Yc._2($jVmMx.Decode.field, "hamburgerTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "hamburgerTargetStyle", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "hamburgerZIndex", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int))), $jVmMx.Decode.fieldWithDefault("hamburgerContainerTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("hamburgerTriggerButtonTarget", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined)), $jVmMx.Decode.fieldWithDefault("hamburgerHomeEnabled", $jVmMx.Decode.bool, false)), $iv6Yc._2($jVmMx.Decode.field, "injectCSS", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "injectJS", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string))), $iv6Yc._2($jVmMx.Decode.field, "breakpointMaxWidth", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.$$int)));
var $9c1add5e29ec5c23$export$a6edb1992047cc25 = {
    insertMode_toJson: $9c1add5e29ec5c23$var$insertMode_toJson,
    insertMode_fromJson: $9c1add5e29ec5c23$var$insertMode_fromJson,
    toJson: $9c1add5e29ec5c23$var$toJson,
    fromJson: $9c1add5e29ec5c23$var$fromJson
};
 /* insertMode_fromJson Not a pure module */ 
});

parcelRegister("dKt0X", function(module, exports) {

$parcel$export(module.exports, "EmailFrequency", function () { return $a02613e7e5630e09$export$ebc71933b3b0487e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");
var $a02613e7e5630e09$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $jVmMx.Decode.fieldWithDefault("weekly", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("monthly", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("yearly", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("daily", $jVmMx.Decode.bool, false), function(weekly, monthly, yearly, daily) {
    return {
        weekly: weekly,
        monthly: monthly,
        yearly: yearly,
        daily: daily
    };
});
function $a02613e7e5630e09$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "weekly",
            $iv6Yc._1($jVmMx.Encode.bool, param.weekly)
        ],
        [
            "monthly",
            $iv6Yc._1($jVmMx.Encode.bool, param.monthly)
        ],
        [
            "yearly",
            $iv6Yc._1($jVmMx.Encode.bool, param.yearly)
        ],
        [
            "daily",
            $iv6Yc._1($jVmMx.Encode.bool, param.daily)
        ]
    ]);
}
var $a02613e7e5630e09$export$ebc71933b3b0487e = {
    fromJson: $a02613e7e5630e09$var$fromJson,
    toJson: $a02613e7e5630e09$var$toJson
};
 /* fromJson Not a pure module */ 
});

parcelRegister("2KZ1D", function(module, exports) {

$parcel$export(module.exports, "PDPStackOffset", function () { return $201f3707a1a17599$export$3b8b4593d16b0fbe; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $79vie = parcelRequire("79vie");

var $AAkl8 = parcelRequire("AAkl8");

var $doJJK = parcelRequire("doJJK");
function $201f3707a1a17599$var$toJson(param) {
    return $AAkl8.object([
        [
            "left",
            $AAkl8.$$int(param.left)
        ],
        [
            "right",
            $AAkl8.$$int(param.right)
        ],
        [
            "bottom",
            $AAkl8.$$int(param.bottom)
        ]
    ]);
}
var $201f3707a1a17599$var$fromJson = $79vie.map3($79vie.field("left", $79vie.$$int), $79vie.field("right", $79vie.$$int), $79vie.field("bottom", $79vie.$$int), function(left, right, bottom) {
    return {
        left: left,
        right: right,
        bottom: bottom
    };
});
var $201f3707a1a17599$var$include = $doJJK.Make({
    toJson: $201f3707a1a17599$var$toJson,
    fromJson: $201f3707a1a17599$var$fromJson
});
var $201f3707a1a17599$var$t_encode = $201f3707a1a17599$var$include.t_encode;
var $201f3707a1a17599$var$t_decode = $201f3707a1a17599$var$include.t_decode;
var $201f3707a1a17599$var$PDPStackOffset_codec = $201f3707a1a17599$var$include.codec;
var $201f3707a1a17599$export$3b8b4593d16b0fbe = {
    toJson: $201f3707a1a17599$var$toJson,
    fromJson: $201f3707a1a17599$var$fromJson,
    t_encode: $201f3707a1a17599$var$t_encode,
    t_decode: $201f3707a1a17599$var$t_decode,
    codec: $201f3707a1a17599$var$PDPStackOffset_codec
};
var $201f3707a1a17599$export$3858a88f1f95fb98 = $201f3707a1a17599$var$t_encode;
var $201f3707a1a17599$export$d595943614c3dff4 = $201f3707a1a17599$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("519Gg", function(module, exports) {

$parcel$export(module.exports, "fromJson", function () { return $3a748e24381dd5b9$export$7ae2d2a8b28a8cb8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $79vie = parcelRequire("79vie");

var $jVmMx = parcelRequire("jVmMx");

var $hQWQG = parcelRequire("hQWQG");

var $5Ax4c = parcelRequire("5Ax4c");
var $3a748e24381dd5b9$var$productData_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "ProductTitle",
        /* ProductTitle */ 0
    ],
    [
        "ProductDescription",
        /* ProductDescription */ 1
    ],
    [
        "ProductPrice",
        /* ProductPrice */ 2
    ],
    [
        "ProductSalePrice",
        /* ProductSalePrice */ 3
    ],
    [
        "ProductSKU",
        /* ProductSKU */ 4
    ],
    [
        "ProductId",
        /* ProductId */ 5
    ],
    [
        "VariantId",
        /* VariantId */ 6
    ]
]);
var $3a748e24381dd5b9$var$availability_fromJson = $79vie.map2($79vie.field("inStockText", $79vie.string), $79vie.field("outOfStockText", $79vie.string), function(inStockText, outOfStockText) {
    return {
        inStockText: inStockText,
        outOfStockText: outOfStockText
    };
});
var $3a748e24381dd5b9$var$source_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("ProductData", $3a748e24381dd5b9$var$productData_fromJson, function(value) {
    return {
        TAG: /* ProductData */ 0,
        _0: value
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("MetaData", $79vie.string, function(value) {
        return {
            TAG: /* MetaData */ 1,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomLabel", $79vie.$$int, function(value) {
        return {
            TAG: /* CustomLabel */ 2,
            _0: value
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Availability", $3a748e24381dd5b9$var$availability_fromJson, function(value) {
        return {
            TAG: /* Availability */ 3,
            _0: value
        };
    })
]);
var $3a748e24381dd5b9$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "source", $3a748e24381dd5b9$var$source_fromJson), $iv6Yc._2($jVmMx.Decode.field, "isRichText", $jVmMx.Decode.bool), $jVmMx.Decode.fieldWithDefault("isPreWrapped", $jVmMx.Decode.bool, false), function(id, source, isRichText, isPreWrapped) {
    return {
        id: id,
        source: source,
        isRichText: isRichText,
        isPreWrapped: isPreWrapped
    };
});
var $3a748e24381dd5b9$var$DynamicSource = {
    productData_fromJson: $3a748e24381dd5b9$var$productData_fromJson,
    metaData_fromJson: $79vie.string,
    customLabel_fromJson: $79vie.$$int,
    availability_fromJson: $3a748e24381dd5b9$var$availability_fromJson,
    source_fromJson: $3a748e24381dd5b9$var$source_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson
};
var $3a748e24381dd5b9$var$source_fromJson$1 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("URL", $jVmMx.Decode.string, function(url) {
    return {
        TAG: /* URL */ 0,
        _0: url
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("MetaData", $jVmMx.Decode.string, function(m) {
        return {
            TAG: /* MetaData */ 1,
            _0: m
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomLabel", $jVmMx.Decode.$$int, function(c) {
        return {
            TAG: /* CustomLabel */ 2,
            _0: c
        };
    })
]);
var $3a748e24381dd5b9$var$altTextSource_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("Text", $jVmMx.Decode.string, function(u) {
    return {
        TAG: /* Text */ 0,
        _0: u
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("MetaData", $jVmMx.Decode.string, function(m) {
        return {
            TAG: /* MetaData */ 1,
            _0: m
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("CustomLabel", $jVmMx.Decode.$$int, function(c) {
        return {
            TAG: /* CustomLabel */ 2,
            _0: c
        };
    })
]);
var $3a748e24381dd5b9$var$fromJson$1 = $79vie.map3($79vie.field("id", $hQWQG.ContentId.fromJson), $79vie.field("source", $3a748e24381dd5b9$var$source_fromJson$1), $79vie.field("altText", $79vie.option($3a748e24381dd5b9$var$altTextSource_fromJson)), function(id, source, altText) {
    return {
        id: id,
        source: source,
        altText: altText
    };
});
var $3a748e24381dd5b9$var$$$Image = {
    source_fromJson: $3a748e24381dd5b9$var$source_fromJson$1,
    altTextSource_fromJson: $3a748e24381dd5b9$var$altTextSource_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$1
};
var $3a748e24381dd5b9$var$fromJson$2 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "text", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "isRichText", $jVmMx.Decode.bool), $jVmMx.Decode.fieldWithDefault("isPreWrapped", $jVmMx.Decode.bool, false), function(id, text, isRichText, isPreWrapped) {
    return {
        id: id,
        text: text,
        isRichText: isRichText,
        isPreWrapped: isPreWrapped
    };
});
var $3a748e24381dd5b9$var$$$Text = {
    fromJson: $3a748e24381dd5b9$var$fromJson$2
};
var $3a748e24381dd5b9$var$fromJson$3 = $79vie.map($79vie.field("id", $hQWQG.ContentId.fromJson), function(id) {
    return {
        id: id
    };
});
var $3a748e24381dd5b9$var$Enhance = {
    fromJson: $3a748e24381dd5b9$var$fromJson$3
};
var $3a748e24381dd5b9$var$cellContent_fromJson = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("DynamicSource", $3a748e24381dd5b9$var$fromJson, function(u) {
    return {
        TAG: /* DynamicSource */ 0,
        _0: u
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Text", $3a748e24381dd5b9$var$fromJson$2, function(m) {
        return {
            TAG: /* Text */ 1,
            _0: m
        };
    })
]);
var $3a748e24381dd5b9$var$style_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "BasicTable",
        /* BasicTable */ 0
    ],
    [
        "HorizontallyScrollableTable",
        /* HorizontallyScrollableTable */ 1
    ],
    [
        "NoBordersTable",
        /* NoBordersTable */ 2
    ]
]);
var $3a748e24381dd5b9$var$fromJson$4 = $iv6Yc._4($jVmMx.Decode.map3, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "cells", $iv6Yc._1($jVmMx.Decode.array, $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$cellContent_fromJson))), $jVmMx.Decode.fieldWithDefault("style", $3a748e24381dd5b9$var$style_fromJson, /* BasicTable */ 0), function(id, cells, style) {
    return {
        id: id,
        cells: cells,
        style: style
    };
});
var $3a748e24381dd5b9$var$Table = {
    cellContent_fromJson: $3a748e24381dd5b9$var$cellContent_fromJson,
    style_fromJson: $3a748e24381dd5b9$var$style_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$4
};
var $3a748e24381dd5b9$var$fromJson$5 = $iv6Yc._3($jVmMx.Decode.map2, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.ContentId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "code", $jVmMx.Decode.string), function(id, code) {
    return {
        id: id,
        code: code
    };
});
var $3a748e24381dd5b9$var$Code = {
    fromJson: $3a748e24381dd5b9$var$fromJson$5
};
var $3a748e24381dd5b9$var$fromJson$6 = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.deccoVariantWithPayload("DynamicSource", $3a748e24381dd5b9$var$fromJson, function(u) {
    return {
        TAG: /* DynamicSource */ 0,
        _0: u
    };
}), [
    $jVmMx.Decode.deccoVariantWithPayload("Text", $3a748e24381dd5b9$var$fromJson$2, function(m) {
        return {
            TAG: /* Text */ 1,
            _0: m
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Image", $3a748e24381dd5b9$var$fromJson$1, function(c) {
        return {
            TAG: /* Image */ 2,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Enhance", $3a748e24381dd5b9$var$fromJson$3, function(c) {
        return {
            TAG: /* Enhance */ 3,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("Table", $3a748e24381dd5b9$var$fromJson$4, function(c) {
        return {
            TAG: /* Table */ 4,
            _0: c
        };
    }),
    $jVmMx.Decode.deccoVariantWithPayload("JavaScript", $3a748e24381dd5b9$var$fromJson$5, function(c) {
        return {
            TAG: /* JavaScript */ 5,
            _0: c
        };
    })
]);
var $3a748e24381dd5b9$export$7c6e2c02157bb7d2 = {
    DynamicSource: $3a748e24381dd5b9$var$DynamicSource,
    $$Image: $3a748e24381dd5b9$var$$$Image,
    $$Text: $3a748e24381dd5b9$var$$$Text,
    Enhance: $3a748e24381dd5b9$var$Enhance,
    Table: $3a748e24381dd5b9$var$Table,
    Code: $3a748e24381dd5b9$var$Code,
    fromJson: $3a748e24381dd5b9$var$fromJson$6
};
var $3a748e24381dd5b9$var$t_v2_decode = $iv6Yc._2($jVmMx.Decode.oneOf, $jVmMx.Decode.simpleVariant([
    [
        "Visible",
        /* Visible */ 0
    ]
]), [
    $jVmMx.Decode.simpleVariant([
        [
            "Hidden",
            /* Hidden */ 1
        ]
    ]),
    $jVmMx.Decode.deccoVariantWithPayload("RuleBased", $5Ax4c.fromJson(undefined), function(rule) {
        return /* RuleBased */ {
            _0: rule
        };
    })
]);
var $3a748e24381dd5b9$var$t_v1_decode = $iv6Yc._2($jVmMx.Decode.andThen, $jVmMx.Decode.$$default($jVmMx.Decode.bool, true), function(visible) {
    return $iv6Yc._1($jVmMx.Decode.succeed, visible ? /* Visible */ 0 : /* Hidden */ 1);
});
var $3a748e24381dd5b9$var$t_decode = $79vie.oneOf($3a748e24381dd5b9$var$t_v2_decode, [
    $3a748e24381dd5b9$var$t_v1_decode
]);
var $3a748e24381dd5b9$export$3824c08153b44726 = {
    t_v2_decode: $3a748e24381dd5b9$var$t_v2_decode,
    t_v1_decode: $3a748e24381dd5b9$var$t_v1_decode,
    t_decode: $3a748e24381dd5b9$var$t_decode,
    fromJson: $3a748e24381dd5b9$var$t_decode
};
var $3a748e24381dd5b9$var$fromJson$7 = $iv6Yc._6($jVmMx.Decode.map5, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "iconUrl", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), function(id, content, title, iconUrl, visible) {
    return {
        id: id,
        content: content,
        title: title,
        iconUrl: iconUrl,
        visible: visible
    };
});
var $3a748e24381dd5b9$export$77fc3e7c6375c538 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$7
};
var $3a748e24381dd5b9$var$accordionState_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "DefaultState",
        /* DefaultState */ 0
    ],
    [
        "AlwaysExpandedState",
        /* AlwaysExpandedState */ 1
    ]
]);
var $3a748e24381dd5b9$var$fromJson$8 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "contents", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$6)), $jVmMx.Decode.fieldWithDefault("accordionState", $3a748e24381dd5b9$var$accordionState_fromJson, /* DefaultState */ 0), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "iconUrl", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), function(id, contents, accordionState, title, iconUrl, visible) {
    return {
        id: id,
        contents: contents,
        accordionState: accordionState,
        title: title,
        iconUrl: iconUrl,
        visible: visible
    };
});
var $3a748e24381dd5b9$export$a66c12e18fc190b1 = {
    accordionState_fromJson: $3a748e24381dd5b9$var$accordionState_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$8
};
var $3a748e24381dd5b9$var$fromJson$9 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "contents", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$6)), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), function(id, contents, title, visible) {
    return {
        id: id,
        contents: contents,
        title: title,
        visible: visible
    };
});
var $3a748e24381dd5b9$export$9586e2f332c8a6f5 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$9
};
var $3a748e24381dd5b9$var$fromJson$10 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "mobileContent", $iv6Yc._1($jVmMx.Decode.option, $3a748e24381dd5b9$var$fromJson$6)), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $jVmMx.Decode.fieldWithDefault("showTitle", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.bool), undefined), function(id, content, mobileContent, title, visible, showTitle) {
    return {
        id: id,
        content: content,
        mobileContent: mobileContent,
        title: title,
        visible: visible,
        showTitle: showTitle
    };
});
var $3a748e24381dd5b9$export$c2963165bf8a9cc9 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$10
};
var $3a748e24381dd5b9$var$fromJson$11 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "backgroundColor", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "textColor", $jVmMx.Decode.string), function(id, content, visible, title, backgroundColor, textColor) {
    return {
        id: id,
        content: content,
        title: title,
        visible: visible,
        backgroundColor: backgroundColor,
        textColor: textColor
    };
});
var $3a748e24381dd5b9$export$37acb3580601e69a = {
    fromJson: $3a748e24381dd5b9$var$fromJson$11
};
var $3a748e24381dd5b9$var$fromJson$12 = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), function(id, title, visible, content) {
    return {
        id: id,
        title: title,
        visible: visible,
        content: content
    };
});
var $3a748e24381dd5b9$export$4d3bb46e028afc86 = {
    fromJson: $3a748e24381dd5b9$var$fromJson$12
};
function $3a748e24381dd5b9$var$showAs_toJson(showAs) {
    if (showAs) return $jVmMx.Encode.simpleVariant([
        [
            "Suffix",
            /* Suffix */ 1
        ]
    ], /* Suffix */ 1);
    else return $jVmMx.Encode.simpleVariant([
        [
            "Prefix",
            /* Prefix */ 0
        ]
    ], /* Prefix */ 0);
}
var $3a748e24381dd5b9$var$showAs_fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Prefix",
        /* Prefix */ 0
    ],
    [
        "Suffix",
        /* Suffix */ 1
    ]
]);
var $3a748e24381dd5b9$var$fromJson$13 = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $hQWQG.SectionId.fromJson), $iv6Yc._2($jVmMx.Decode.field, "title", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "visible", $3a748e24381dd5b9$var$t_decode), $iv6Yc._2($jVmMx.Decode.field, "visibleInProductCard", $jVmMx.Decode.bool), $iv6Yc._2($jVmMx.Decode.field, "content", $3a748e24381dd5b9$var$fromJson$6), $iv6Yc._2($jVmMx.Decode.field, "showAs", $3a748e24381dd5b9$var$showAs_fromJson), function(id, title, visible, visibleInProductCard, content, showAs) {
    return {
        id: id,
        title: title,
        visible: visible,
        visibleInProductCard: visibleInProductCard,
        showAs: showAs,
        content: content
    };
});
var $3a748e24381dd5b9$export$4ba25fc295a936e5 = {
    showAs_toJson: $3a748e24381dd5b9$var$showAs_toJson,
    showAs_fromJson: $3a748e24381dd5b9$var$showAs_fromJson,
    fromJson: $3a748e24381dd5b9$var$fromJson$13
};
var $3a748e24381dd5b9$export$7ae2d2a8b28a8cb8 = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(summarySections, detailedSections, promoSection, promoSections, enhanceSection, enhanceSections, badges, reviews, priceLabels) {
    return {
        summarySections: summarySections,
        detailedSections: detailedSections,
        promoSection: promoSection,
        promoSections: promoSections,
        enhanceSection: enhanceSection,
        enhanceSections: enhanceSections,
        badges: badges,
        reviews: reviews,
        priceLabels: priceLabels
    };
}), $iv6Yc._2($jVmMx.Decode.field, "summarySections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$7))), $iv6Yc._2($jVmMx.Decode.field, "detailedSections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$8))), $iv6Yc._2($jVmMx.Decode.field, "promoSection", $3a748e24381dd5b9$var$fromJson$9)), $iv6Yc._2($jVmMx.Decode.field, "promoSections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$9))), $iv6Yc._2($jVmMx.Decode.field, "enhanceSection", $iv6Yc._1($jVmMx.Decode.option, $3a748e24381dd5b9$var$fromJson$10))), $iv6Yc._2($jVmMx.Decode.field, "enhanceSections", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$10))), $iv6Yc._2($jVmMx.Decode.field, "badges", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$11))), $iv6Yc._2($jVmMx.Decode.field, "reviews", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$12))), $iv6Yc._2($jVmMx.Decode.field, "priceLabels", $iv6Yc._1($jVmMx.Decode.array, $3a748e24381dd5b9$var$fromJson$13)));
 /* productData_fromJson Not a pure module */ 
});
parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});


parcelRegister("3DzsH", function(module, exports) {

$parcel$export(module.exports, "PDPStackPosition", function () { return $2a6085a10ae0f556$export$415b50f68bbf06b9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $2a6085a10ae0f556$var$partial_arg = [
    [
        "left",
        "left"
    ],
    [
        "right",
        "right"
    ]
];
function $2a6085a10ae0f556$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($2a6085a10ae0f556$var$partial_arg, param);
}
var $2a6085a10ae0f556$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "left",
        "left"
    ],
    [
        "right",
        "right"
    ]
]);
var $2a6085a10ae0f556$var$include = $doJJK.Make({
    toJson: $2a6085a10ae0f556$var$toJson,
    fromJson: $2a6085a10ae0f556$var$fromJson
});
var $2a6085a10ae0f556$var$t_encode = $2a6085a10ae0f556$var$include.t_encode;
var $2a6085a10ae0f556$var$t_decode = $2a6085a10ae0f556$var$include.t_decode;
var $2a6085a10ae0f556$var$PDPStackPosition_codec = $2a6085a10ae0f556$var$include.codec;
var $2a6085a10ae0f556$export$415b50f68bbf06b9 = {
    toJson: $2a6085a10ae0f556$var$toJson,
    fromJson: $2a6085a10ae0f556$var$fromJson,
    t_encode: $2a6085a10ae0f556$var$t_encode,
    t_decode: $2a6085a10ae0f556$var$t_decode,
    codec: $2a6085a10ae0f556$var$PDPStackPosition_codec
};
var $2a6085a10ae0f556$export$ba0687c1b64f2741 = $2a6085a10ae0f556$var$t_encode;
var $2a6085a10ae0f556$export$4f5b40d481e36a38 = $2a6085a10ae0f556$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("9BF9g", function(module, exports) {

$parcel$export(module.exports, "ProductCardStyle", function () { return $6fe77cf38fcab3ee$export$43cb186979960ddc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $6fe77cf38fcab3ee$var$containerStyle_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "borderColor",
            $iv6Yc._1($jVmMx.Encode.string, param.borderColor)
        ],
        [
            "borderWidth",
            $iv6Yc._1($jVmMx.Encode.string, param.borderWidth)
        ],
        [
            "borderRadius",
            $iv6Yc._1($jVmMx.Encode.string, param.borderRadius)
        ],
        [
            "padding",
            $iv6Yc._1($jVmMx.Encode.string, param.padding)
        ],
        [
            "backgroundColor",
            $iv6Yc._1($jVmMx.Encode.string, param.backgroundColor)
        ],
        [
            "overflow",
            $iv6Yc._1($jVmMx.Encode.string, param.overflow)
        ],
        [
            "cssCode",
            $jVmMx.Encode.nullable(param.cssCode, $jVmMx.Encode.string)
        ]
    ]);
}
var $6fe77cf38fcab3ee$var$containerStyle_fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(borderColor, borderWidth, borderRadius, padding, backgroundColor, overflow, cssCode) {
    return {
        borderColor: borderColor,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        padding: padding,
        backgroundColor: backgroundColor,
        overflow: overflow,
        cssCode: cssCode
    };
}), $iv6Yc._2($jVmMx.Decode.field, "borderColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "borderWidth", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "borderRadius", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "padding", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "backgroundColor", $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "overflow", $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("cssCode", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string), undefined));
function $6fe77cf38fcab3ee$var$genericStyle_toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "cssCode",
            $jVmMx.Encode.nullable(param.cssCode, $jVmMx.Encode.string)
        ]
    ]);
}
var $6fe77cf38fcab3ee$var$genericStyle_fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(cssCode) {
    return {
        cssCode: cssCode
    };
}), $jVmMx.Decode.fieldWithDefault("cssCode", $iv6Yc._1($jVmMx.Decode.nullable, $jVmMx.Decode.string), undefined));
function $6fe77cf38fcab3ee$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "container",
            $6fe77cf38fcab3ee$var$containerStyle_toJson(param.container)
        ],
        [
            "badge",
            $6fe77cf38fcab3ee$var$genericStyle_toJson(param.badge)
        ]
    ]);
}
var $6fe77cf38fcab3ee$var$fromJson = $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._2($jVmMx.Decode.andMap, $iv6Yc._1($jVmMx.Decode.succeed, function(container, badge) {
    return {
        container: container,
        badge: badge
    };
}), $iv6Yc._2($jVmMx.Decode.field, "container", $6fe77cf38fcab3ee$var$containerStyle_fromJson)), $jVmMx.Decode.fieldWithDefault("badge", $6fe77cf38fcab3ee$var$genericStyle_fromJson, {
    cssCode: undefined
}));
var $6fe77cf38fcab3ee$var$include = $doJJK.Make({
    toJson: $6fe77cf38fcab3ee$var$toJson,
    fromJson: $6fe77cf38fcab3ee$var$fromJson
});
var $6fe77cf38fcab3ee$var$ProductCardStyle_t_encode = $6fe77cf38fcab3ee$var$include.t_encode;
var $6fe77cf38fcab3ee$var$ProductCardStyle_t_decode = $6fe77cf38fcab3ee$var$include.t_decode;
var $6fe77cf38fcab3ee$var$ProductCardStyle_codec = $6fe77cf38fcab3ee$var$include.codec;
var $6fe77cf38fcab3ee$export$43cb186979960ddc = {
    containerStyle_toJson: $6fe77cf38fcab3ee$var$containerStyle_toJson,
    containerStyle_fromJson: $6fe77cf38fcab3ee$var$containerStyle_fromJson,
    genericStyle_toJson: $6fe77cf38fcab3ee$var$genericStyle_toJson,
    genericStyle_fromJson: $6fe77cf38fcab3ee$var$genericStyle_fromJson,
    toJson: $6fe77cf38fcab3ee$var$toJson,
    fromJson: $6fe77cf38fcab3ee$var$fromJson,
    t_encode: $6fe77cf38fcab3ee$var$ProductCardStyle_t_encode,
    t_decode: $6fe77cf38fcab3ee$var$ProductCardStyle_t_decode,
    codec: $6fe77cf38fcab3ee$var$ProductCardStyle_codec
};
 /* containerStyle_fromJson Not a pure module */ 
});

parcelRegister("f4o9q", function(module, exports) {

$parcel$export(module.exports, "ProductPriceStyle", function () { return $af89f6a10d4b21e1$export$d0b060296d2f03da; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
var $af89f6a10d4b21e1$var$partial_arg = [
    [
        "Default",
        /* Default */ 0
    ],
    [
        "VariantPricesRange",
        /* VariantPricesRange */ 1
    ]
];
function $af89f6a10d4b21e1$var$toJson(param) {
    return $jVmMx.Encode.simpleVariant($af89f6a10d4b21e1$var$partial_arg, param);
}
var $af89f6a10d4b21e1$var$fromJson = $jVmMx.Decode.simpleVariant([
    [
        "Default",
        /* Default */ 0
    ],
    [
        "VariantPricesRange",
        /* VariantPricesRange */ 1
    ]
]);
var $af89f6a10d4b21e1$var$include = $doJJK.Make({
    toJson: $af89f6a10d4b21e1$var$toJson,
    fromJson: $af89f6a10d4b21e1$var$fromJson
});
var $af89f6a10d4b21e1$var$t_encode = $af89f6a10d4b21e1$var$include.t_encode;
var $af89f6a10d4b21e1$var$t_decode = $af89f6a10d4b21e1$var$include.t_decode;
var $af89f6a10d4b21e1$var$ProductPriceStyle_codec = $af89f6a10d4b21e1$var$include.codec;
var $af89f6a10d4b21e1$export$d0b060296d2f03da = {
    toJson: $af89f6a10d4b21e1$var$toJson,
    fromJson: $af89f6a10d4b21e1$var$fromJson,
    t_encode: $af89f6a10d4b21e1$var$t_encode,
    t_decode: $af89f6a10d4b21e1$var$t_decode,
    codec: $af89f6a10d4b21e1$var$ProductPriceStyle_codec
};
var $af89f6a10d4b21e1$export$23c44dec1d1b5f74 = $af89f6a10d4b21e1$var$t_encode;
var $af89f6a10d4b21e1$export$9374040f1a164e16 = $af89f6a10d4b21e1$var$t_decode;
 /* fromJson Not a pure module */ 
});

parcelRegister("2d3Mr", function(module, exports) {

$parcel$export(module.exports, "ConnectedGAPropertyCodecs", function () { return $19bfba5bbfaeb90e$export$6d673ceccd4eb2bc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $19bfba5bbfaeb90e$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "displayName",
            $iv6Yc._1($jVmMx.Encode.string, param.displayName)
        ],
        [
            "timeZone",
            $jVmMx.Encode.nullable(param.timeZone, $jVmMx.Encode.string)
        ],
        [
            "adminClerkId",
            $iv6Yc._1($jVmMx.Encode.string, param.adminClerkId)
        ]
    ]);
}
var $19bfba5bbfaeb90e$var$fromJson = $iv6Yc._5($jVmMx.Decode.map4, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "displayName", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "timeZone", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $iv6Yc._2($jVmMx.Decode.field, "adminClerkId", $jVmMx.Decode.string), function(id, displayName, timeZone, adminClerkId) {
    return {
        id: id,
        displayName: displayName,
        timeZone: timeZone,
        adminClerkId: adminClerkId
    };
});
var $19bfba5bbfaeb90e$var$include = $doJJK.Make({
    toJson: $19bfba5bbfaeb90e$var$toJson,
    fromJson: $19bfba5bbfaeb90e$var$fromJson
});
var $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_encode = $19bfba5bbfaeb90e$var$include.t_encode;
var $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_decode = $19bfba5bbfaeb90e$var$include.t_decode;
var $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_codec = $19bfba5bbfaeb90e$var$include.codec;
var $19bfba5bbfaeb90e$export$6d673ceccd4eb2bc = {
    toJson: $19bfba5bbfaeb90e$var$toJson,
    fromJson: $19bfba5bbfaeb90e$var$fromJson,
    t_encode: $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_encode,
    t_decode: $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_t_decode,
    codec: $19bfba5bbfaeb90e$var$ConnectedGAPropertyCodecs_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("cAXsd", function(module, exports) {

$parcel$export(module.exports, "ConnectedTiktokAccount", function () { return $92b6f72a16144da9$export$8ef4f26b0eec859c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $92b6f72a16144da9$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "handle",
            $iv6Yc._1($jVmMx.Encode.string, param.handle)
        ],
        [
            "biography",
            $jVmMx.Encode.nullable(param.biography, $jVmMx.Encode.string)
        ],
        [
            "profilePictureUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.profilePictureUrl)
        ],
        [
            "autoSync",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoSync)
        ],
        [
            "adminClerkId",
            $iv6Yc._1($jVmMx.Encode.string, param.adminClerkId)
        ]
    ]);
}
var $92b6f72a16144da9$var$fromJson = $iv6Yc._7($jVmMx.Decode.map6, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "handle", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "biography", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("profilePictureUrl", $jVmMx.Decode.string, ""), $jVmMx.Decode.fieldWithDefault("autoSync", $jVmMx.Decode.bool, true), $iv6Yc._2($jVmMx.Decode.field, "adminClerkId", $jVmMx.Decode.string), function(id, handle, biography, profilePictureUrl, autoSync, adminClerkId) {
    return {
        id: id,
        handle: handle,
        biography: biography,
        profilePictureUrl: profilePictureUrl,
        autoSync: autoSync,
        adminClerkId: adminClerkId
    };
});
var $92b6f72a16144da9$var$include = $doJJK.Make({
    toJson: $92b6f72a16144da9$var$toJson,
    fromJson: $92b6f72a16144da9$var$fromJson
});
var $92b6f72a16144da9$var$ConnectedTiktokAccount_t_encode = $92b6f72a16144da9$var$include.t_encode;
var $92b6f72a16144da9$var$ConnectedTiktokAccount_t_decode = $92b6f72a16144da9$var$include.t_decode;
var $92b6f72a16144da9$var$ConnectedTiktokAccount_codec = $92b6f72a16144da9$var$include.codec;
var $92b6f72a16144da9$export$8ef4f26b0eec859c = {
    toJson: $92b6f72a16144da9$var$toJson,
    fromJson: $92b6f72a16144da9$var$fromJson,
    t_encode: $92b6f72a16144da9$var$ConnectedTiktokAccount_t_encode,
    t_decode: $92b6f72a16144da9$var$ConnectedTiktokAccount_t_decode,
    codec: $92b6f72a16144da9$var$ConnectedTiktokAccount_codec
};
 /* fromJson Not a pure module */ 
});

parcelRegister("aHg7U", function(module, exports) {

$parcel$export(module.exports, "ConnectedInstagramAccount", function () { return $7c9a6df2611ee45f$export$dba60373f79bbb79; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $jVmMx = parcelRequire("jVmMx");

var $doJJK = parcelRequire("doJJK");
function $7c9a6df2611ee45f$var$toJson(param) {
    return $iv6Yc._1($jVmMx.Encode.object, [
        [
            "id",
            $iv6Yc._1($jVmMx.Encode.string, param.id)
        ],
        [
            "handle",
            $iv6Yc._1($jVmMx.Encode.string, param.handle)
        ],
        [
            "isPersonal",
            $iv6Yc._1($jVmMx.Encode.bool, param.isPersonal)
        ],
        [
            "biography",
            $jVmMx.Encode.nullable(param.biography, $jVmMx.Encode.string)
        ],
        [
            "profilePictureUrl",
            $iv6Yc._1($jVmMx.Encode.string, param.profilePictureUrl)
        ],
        [
            "autoSync",
            $iv6Yc._1($jVmMx.Encode.bool, param.autoSync)
        ],
        [
            "adminClerkId",
            $jVmMx.Encode.nullable(param.adminClerkId, $jVmMx.Encode.string)
        ]
    ]);
}
var $7c9a6df2611ee45f$var$fromJson = $iv6Yc._8($jVmMx.Decode.map7, $iv6Yc._2($jVmMx.Decode.field, "id", $jVmMx.Decode.string), $iv6Yc._2($jVmMx.Decode.field, "handle", $jVmMx.Decode.string), $jVmMx.Decode.fieldWithDefault("isPersonal", $jVmMx.Decode.bool, false), $iv6Yc._2($jVmMx.Decode.field, "biography", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string)), $jVmMx.Decode.fieldWithDefault("profilePictureUrl", $jVmMx.Decode.string, ""), $jVmMx.Decode.fieldWithDefault("autoSync", $jVmMx.Decode.bool, true), $jVmMx.Decode.fieldWithDefault("adminClerkId", $iv6Yc._1($jVmMx.Decode.option, $jVmMx.Decode.string), undefined), function(id, handle, isPersonal, biography, profilePictureUrl, autoSync, adminClerkId) {
    return {
        id: id,
        handle: handle,
        isPersonal: isPersonal,
        biography: biography,
        profilePictureUrl: profilePictureUrl,
        autoSync: autoSync,
        adminClerkId: adminClerkId
    };
});
var $7c9a6df2611ee45f$var$include = $doJJK.Make({
    toJson: $7c9a6df2611ee45f$var$toJson,
    fromJson: $7c9a6df2611ee45f$var$fromJson
});
var $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_encode = $7c9a6df2611ee45f$var$include.t_encode;
var $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_decode = $7c9a6df2611ee45f$var$include.t_decode;
var $7c9a6df2611ee45f$var$ConnectedInstagramAccount_codec = $7c9a6df2611ee45f$var$include.codec;
var $7c9a6df2611ee45f$export$dba60373f79bbb79 = {
    toJson: $7c9a6df2611ee45f$var$toJson,
    fromJson: $7c9a6df2611ee45f$var$fromJson,
    t_encode: $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_encode,
    t_decode: $7c9a6df2611ee45f$var$ConnectedInstagramAccount_t_decode,
    codec: $7c9a6df2611ee45f$var$ConnectedInstagramAccount_codec
};
 /* fromJson Not a pure module */ 
});




})();
//# sourceMappingURL=ConfigurationDecoder.bs.b1f81d12.js.map
